export default function sortString(column, sortAsc) {
  let sortBy = column
  if (sortBy === 'status') {
    sortBy += '_cd'
  }

  return `${sortAsc ? '' : '-'}order_requests.${sortBy}`
}
